import React from 'react';
import { Home } from '../../components/navigation/Home'; // url for this one is wwrong because this link is on developer AND sm.com
import { MyApps } from '../../components/navigation/MyApps';
import { Docs } from '../../components/navigation/Docs';
import { Status } from '../../components/navigation/Status';
import { FAQ } from '../../components/navigation/FAQ';

import { UserMenu } from '../../components/user-menu';

import { Variant } from '../types';

const developer: Variant = {
  brand: 'SurveyMonkey',
  title: 'Developer',
  menu: [
    <Home key="menu-home" />,
    <MyApps key="menu-myapps" />,
    <Docs key="menu-docs" />,
    <Status key="menu-status" />,
    <FAQ key="menu-faq" />,
  ],
  actions: [],
  info: [],
  user: [<UserMenu key="menu-user" />],
  homePage: '/',
};

export default developer;
